export const FOOTER_INFO = {
  copyright: `© ${new Date().getFullYear()} AI Carma. Proudly Built in Texas`,
  address: "8350 N Central Expy, Suite 1900, Dallas, TX 75206",
  email: "support@aicarma.com"
};